import React, { useContext } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import { AppContext } from '../../../state/AppContext';
import { reportRedirectButtonClicked } from '../../../utils/report/bigquery';
import { getGigPath, getSubCategoryPath } from '../../../../../server/utils/api';

const RedirectButton = () => {
    const { locale } = getContext();
    const storeContext = useContext(AppContext);
    const {
        gig: { slug, categoryId, subCategoryId },
        seller: { name: sellerUsername },
    } = storeContext;

    const getRedirectUrl = () => {
        if (slug) {
            return getGigPath({ username: sellerUsername, slug });
        } else {
            return getSubCategoryPath({ categoryId, subCategoryId }, locale);
        }
    };

    const onClick = () => {
        const redirectUrl = getRedirectUrl();

        reportRedirectButtonClicked(storeContext, {
            redirectUrl,
            info: slug ? 'redirect to gig page' : 'redirect to subcategory listing page',
        });

        window.location.assign(redirectUrl);
    };

    return (
        <Button onClick={onClick}>
            <I18n k={'assets_sharing.overview_card.redirect_button.label'} />
        </Button>
    );
};

export default RedirectButton;
